export enum RouteParameters {
  reportUid = "reportUid",
  templateUid = "templateUid",
  projectUid = "projectUid",
}
